export function getData() {
  return [
    {
      quarter: "Bankura",
      Target : 140,
      Achieved: 16
    },
    {
      quarter: "Nadia",
      Target: 124,
      Achieved: 20
    },
    {
      quarter: "Hooghly",
      Target: 112,
      Achieved: 20
    },
    {
      quarter: "Howrah",
      Target: 118,
      Achieved: 24
    },
    {
      quarter: "Purulia",
      Target: 118,
      Achieved: 24
    },
    {
      quarter: "Birbhum",
      Target: 118,
      Achieved: 24
    },
  ];
}

export function getPaymentData() {
  return [
    { district: "Bankura", disbursed: 1245000 },
    { district: "Nadia", disbursed: 985000 },
    { district: "Hooghly", disbursed: 1350000 },
    { district: "Howrah", disbursed: 1100000 },
    { district: "Purulia", disbursed: 890000 },
    { district: "Birbhum", disbursed: 1030000 },
  ];
}